import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ServicesAPI from "../../services/services";
import { storeLeadID } from "../../utils/storage";
import { storeCustomerTypeAndAppVersion } from "../../lib/script";
import useResponse from "../../hooks/useResponse";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";
const packageJson = require("../../../package.json");

const Reloan = () => {
    const [ loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { handleStep } = useResponse();
    const { dashboardAPI } = new ServicesAPI();
    const fetchDetails = async () => {
        try {
            const res = await dashboardAPI();
            if (res && res?.statusCode === 200) {
                const leadID = res?.data?.lead?.leadID;
                if (leadID) {
                    storeLeadID(leadID);
                } else {
                    storeLeadID("");
                }
                storeCustomerTypeAndAppVersion(res.data.customer_type, packageJson.version);
                handleRedirection(res)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }


    }
    const handleRedirection = async (data) => {
        if (data.showContactPage) {
            navigate("/contact-us");
        } else if (data.isRejected) {
            navigate("/loan-reject");
        } else if (data?.step?.current_route === "/pan-verify") {
            navigate(data?.step?.current_route);
        } else if (data?.step?.current_route === "/enter-aadhar") {
            navigate(data?.step?.current_route);
        } else if (data?.lead?.status === "Approved Process") {
            navigate("/select-loan");
        } else {
            handleStep();
        }
    }
    useEffect(() => {
        if(loading) {
          handleShowContextualLoader("Please wait...");
          return;
        } else {
          handlehideContextualLoader();
        }
        return () => {
          handlehideContextualLoader();
        };
      }, [loading]);
    
    useEffect(() => {
        fetchDetails();
    }, [])
    return null;
}

export default Reloan;